// extracted by mini-css-extract-plugin
export var measureBox = "_53-0";